import { TRACKERS } from "@/constants/Trackers";
import { Messages } from "@/features/Messages";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/messages")({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_INBOX);
  },
});

function RouteComponent() {
  return <Messages />;
}
